import React from 'react';
import {get} from 'lodash';
import axios from 'axios';

import {
  canEdit,
  canKenta,
} from '../lib/policies';

import {
  requestCallback,
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import UserWithImage from './UserWithImage';
import PenaltyTools from './PenaltyTools';
import Modal from './Modal';

const GroupMember = ({
  user,
  groupId,
  role,
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModal = (data) => () => {
    modalSet(data)
  }

  const handleRequest = () => {
    const url = `/${gon.currentProvider}/api/group_users/${get(user, 'groupUserStatuses.id')}/${modal}`

    requestCallback(axios.get(url, {
      params: {
        user_id: get(user, 'id'),
        group_id: groupId,
      }
    }))
  }

  return (
    <React.Fragment>
      <div className='Table__row'>
        <div className='Table__col Table__col--compact'>
          <div className='Table__member'>
            <UserWithImage
              hideNickname
              user={user}
            />
          </div>
        </div>

        <div className='Table__col Table__col--group-member'>
          <ul className='Table__member__ul'>
            {role !== 'Member' && <li>{role}</li>}

            {role !== 'Owner' && canEdit('Group') &&
              <React.Fragment>
                <li>
                  {role === 'Member' ?
                    <a onClick={onToggleModal('promote')}>set admin</a>
                  :
                    <a onClick={onToggleModal('demote')}>lift admin</a>
                  }
                </li>

                <li>
                  <a onClick={onToggleModal('kick')}>kick</a>
                </li>
              </React.Fragment>
            }
          </ul>
        </div>

        <div className='Table__col Table__col--compact Table__col--center'>
          {canKenta('Group') && get(user, 'type') !== 'deleted' &&
            <PenaltyTools
              userId={get(user, 'id')}
              bannedTimeLeft={get(user, 'bannedTimeLeft')}
              type="Group"
              banUntil={get(user, 'banUntil')}
              isBanned={get(user, 'isBanned')}
            />
          }
        </div>
      </div>

      <Modal
        isActive={modal}
        onToggleModal={onToggleModal(null)}
      >
        <h3 className='Modal__h3'>
          {(() => {
            switch (modal) {
              case 'promote': return `Promote user ${get(user, 'id')} to admin`
              case 'demote': return `Demote user ${get(user, 'id')} from admin`
              case 'kick': return `Kick user ${get(user, 'id')} from group`
            }
          })()}
        </h3>

        <div className='Modal__p__wrapper'>
          <p className='Modal__p'>Are you sure you want to proceed</p>
        </div>

        <div className='Modal__footer Modal__footer--without-border'>
          <a
            className='Button Button--gray-light'
            onClick={onToggleModal(null)}
          >
            Cancel
          </a>

          <button
            className='Button Button--blue'
            onClick={handleRequest}
            ref={$submitButton}
          >
            Submit
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default GroupMember
